export default [
    {
        path: '/warehouse',
        name: 'warehouse',
        component: () => import('@/views/warehouse/WarehousesView.vue'),
    },
    {
        path: '/warehouse/:id',
        name: 'warehouse-detail',
        component: () => import('@/views/warehouse/WarehouseView.vue'),
    }
]
